import { AbstractControl, FormControl } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-field-enter-error',
  templateUrl: './field-enter-error.component.html',
  styleUrls: ['./field-enter-error.component.scss'],
})
export class FieldEnterErrorComponent implements OnInit {
  @Input() control: AbstractControl | null = new FormControl();
  @Input() fieldName = '';
  @Input() errorName = '';
  @Input() errorMsg = '';
  @Input() isShowError = false;
  constructor() {}
  ngOnInit(): void {}
}
